export default "__VITE_ASSET__D97rbz_f__"